module.exports = __webpack_public_path__ + "img/elem_water.4f190dad.svg";